import { useEffect } from 'react';

export default function WebsiteRedirect() {
  useEffect(() => {
    try {
      const hash = window.location.hash || '';
      window.location.replace('/website/index.html' + hash);
    } catch (_) {}
  }, []);
  return null;
}
